//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
    }
  },
  emits: [
    'onAppointment',
    // 'closePopup'
  ],
  props: {
    specialist: {
      type: [Array, Object],
      requared: true,
    },
    isAppointment: {
      type: Boolean,
      requared: false,
      default() {
        return false
      }
    },
    scroll: {
      type: Boolean,
      default() {
        return false
      }
    },
  },
  computed: {
    salons() {
      let specialist = this.specialist;
      let store = specialist[0]?.stores || [];
      return store;
    }
  },
  methods: {
    removeBlur: function () {
      document.querySelector('.specialist-info-blur').classList.add('specialist-info-blur_hidden')
    },
    // closePopup: function () {
    //   this.$emit('closePopup');
    // }
  },
  mounted: function () {
    window.addEventListener('scroll', this.removeBlur)
  },
  unMounted: function () {
    window.removeEventListener('scroll', this.removeBlur)
  }
}
